import styled from 'styled-components';

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 2.8rem;
  padding: ${({ theme }) => theme.spacing(0, 1, 0, 3)};

  background: ${({ theme }) => theme.palette.grey[100]};
  border-radius: ${({ theme }) => theme.spacing(8)};
`;

export const Input = styled.input`
  flex: 1;
  min-width: 0;
  width: 14rem;
  height: 100%;

  border: none;
  outline: none;
  background: transparent;

  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: 1.4rem;
  color: ${({ theme }) => theme.palette.text.primary};

  &::placeholder {
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;
